/* Generated by brand/scripts/sync-mfe-chrome.py. Do not edit. */
const defaults = {
  "loginUrl": "https://auth.brainandspinegroup.org/realms/BSG/protocol/openid-connect/auth",
  "logoutUrl": "/logout",
  "websiteUrl": "https://www.brainandspinegroup.org",
  "learnUrl": "https://learn.brainandspinegroup.org",
  "shopUrl": "https://shop.brainandspinegroup.org",
  "donateUrl": "https://support.brainandspinegroup.org",
  "donateWidgetSrc": "https://secure.givelively.org/widgets/simple_donation/brain-and-spine-group.js?show_suggested_amount_buttons=true&show_in_honor_of=true&address_required=false&has_required_custom_question=null&suggested_donation_amounts[]=50&suggested_donation_amounts[]=100&suggested_donation_amounts[]=250&suggested_donation_amounts[]=500",
  "donateHeading": "100% Community Supported",
  "donateBlurb": "Community and foundation funding ensures Brain & Spine Group continues to bring open education to the world and mentor students toward becoming the researchers of tomorrow.",
  "donateLearnMore": "Learn more",
  "donateClose": "Close donate",
  "helpUrl": "https://learn.brainandspinegroup.org/help/",
  "coursesUrl": "/courses",
  "dashboardUrl": "/dashboard",
  "shopAccountUrl": "https://shop.brainandspinegroup.org/account",
  "bsgidAccountUrl": "https://auth.brainandspinegroup.org/realms/BSG/account",
  "skipLink": "Skip to content",
  "primaryNavLabel": "Primary",
  "mobileNavLabel": "Mobile primary",
  "menuToggle": "Menu Toggle",
  "utilityLabel": "Sites and account",
  "switcherLabel": "{current}, switch site",
  "newTab": "Open {name} in a new tab",
  "accountSignedOut": "Account",
  "signInLabel": "Sign in with BSG ID",
  "signOutLabel": "Sign out",
  "shopAccountLabel": "Shop account",
  "learnDashboardLabel": "BSG Learn",
  "bsgidAccountLabel": "BSG ID account",
  "donateNow": "Donate now",
  "loginNote": "Login required*",
  "switcherMain": "Main Site",
  "switcherLearn": "BSG Learn",
  "switcherShop": "BSG Shop",
  "subbrandName": "BSG Learn",
  "showLearnColumn": true,
  "siteLogoAlt": "Brain & Spine Group",
  "primaryNav": [
    {
      "label": "Support",
      "href": "https://www.brainandspinegroup.org/support",
      "external": false,
      "children": [
        {
          "label": "Supporters and Donors",
          "href": "https://www.brainandspinegroup.org/support",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Donate today!",
          "href": "https://support.brainandspinegroup.org",
          "external": false,
          "requires_login": false,
          "donate": true
        }
      ]
    },
    {
      "label": "Learn",
      "href": "https://www.brainandspinegroup.org/learn",
      "external": false,
      "children": [
        {
          "label": "Education Programs",
          "href": "https://www.brainandspinegroup.org/learn",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Education Resources",
          "href": "https://www.brainandspinegroup.org/resources?audience=education",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "The Brain & Spine Report",
          "href": "https://www.brainandspinegroup.org/report",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "BSG Learn",
          "href": "https://learn.brainandspinegroup.org",
          "external": true,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "BSG Slack",
          "href": "https://brainandspinegroup.slack.com",
          "external": true,
          "requires_login": true,
          "donate": false
        }
      ]
    },
    {
      "label": "Mentor",
      "href": "https://www.brainandspinegroup.org/mentor",
      "external": false,
      "children": [
        {
          "label": "Mentorship Programs",
          "href": "https://www.brainandspinegroup.org/mentor",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "END Program",
          "href": "https://www.brainandspinegroup.org/mentor/end",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "NERVE Program",
          "href": "https://www.brainandspinegroup.org/mentor/neurosurgery-education-research-virtual-experience-nerve",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Mentorship Resources",
          "href": "https://www.brainandspinegroup.org/resources?audience=mentorship",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "The Brain & Spine Report",
          "href": "https://www.brainandspinegroup.org/report",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "BSG Slack",
          "href": "https://brainandspinegroup.slack.com",
          "external": true,
          "requires_login": true,
          "donate": false
        }
      ]
    },
    {
      "label": "Discover",
      "href": "https://www.brainandspinegroup.org/research",
      "external": false,
      "children": [
        {
          "label": "Research Program",
          "href": "https://www.brainandspinegroup.org/research",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Radwanski & Pannullo",
          "href": "https://www.brainandspinegroup.org/research/radwanski-pannullo-research",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "D’Amico Research Team",
          "href": "https://www.brainandspinegroup.org/research/damico-research",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Ukachukwu",
          "href": "https://www.brainandspinegroup.org/research/ukachukwu-research",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Lai",
          "href": "https://www.brainandspinegroup.org/research/lai-research",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Browse our Publications",
          "href": "https://www.brainandspinegroup.org/publications",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "Research Resources",
          "href": "https://www.brainandspinegroup.org/resources?audience=research",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "The Brain & Spine Report",
          "href": "https://www.brainandspinegroup.org/report",
          "external": false,
          "requires_login": false,
          "donate": false
        },
        {
          "label": "BSG Slack",
          "href": "https://brainandspinegroup.slack.com",
          "external": true,
          "requires_login": true,
          "donate": false
        }
      ]
    }
  ],
  "subbrandItems": [
    {
      "label": "Courses",
      "href": "/courses",
      "key": "courses"
    },
    {
      "label": "Dashboard",
      "href": "/dashboard",
      "key": "dashboard"
    },
    {
      "label": "Help",
      "href": "https://learn.brainandspinegroup.org/help/",
      "key": "help"
    }
  ],
  "siteLogoUrl": "../assets/bsg-logo.png",
  "learnLogoUrl": "../assets/bsg-learn-logo.png",
  "footerMarkUrl": "../assets/bsg-mark-on-dark.png",
  "learnerApps": [
    "learner-dashboard",
    "learning",
    "discussions",
    "account",
    "profile",
    "catalog"
  ],
  "studioApps": [
    "authoring",
    "instructor-dashboard",
    "gradebook",
    "ora-grading",
    "admin-console",
    "communications"
  ],
  "footerColumns": [
    {
      "id": "support-us",
      "title": "Support Us",
      "scope": "all",
      "links": [
        {
          "title": "Supporter Info",
          "url": "https://brainandspinegroup.org/support/"
        },
        {
          "title": "Giving Portal",
          "url": "https://secure.givelively.org/users/sign_in",
          "external": true
        },
        {
          "title": "Annual Impact report",
          "url": "https://brainandspinegroup.org/wp-content/uploads/2025/04/2025ImpactReport_Updated.pdf"
        }
      ]
    },
    {
      "id": "our-programs",
      "title": "Our Programs",
      "scope": "all",
      "links": [
        {
          "title": "Education",
          "url": "https://brainandspinegroup.org/education-event/"
        },
        {
          "title": "Mentorship",
          "url": "https://brainandspinegroup.org/mentorship-program/"
        },
        {
          "title": "Research",
          "url": "https://brainandspinegroup.org/research-teams/"
        }
      ]
    },
    {
      "id": "resources",
      "title": "Resources",
      "scope": "all",
      "links": [
        {
          "title": "BSG Learn",
          "url": "/"
        },
        {
          "title": "YouTube Channel",
          "url": "https://www.youtube.com/@BrainSpineGroup",
          "external": true
        }
      ]
    },
    {
      "id": "applications",
      "title": "Applications",
      "scope": "all",
      "links": [
        {
          "title": "BSG Slack",
          "url": "https://brainandspinegroup.slack.com",
          "external": true
        },
        {
          "title": "Stats Center",
          "url": "https://stats.brainandspinegroup.org",
          "external": true
        },
        {
          "title": "Data Center",
          "url": "https://data.brainandspinegroup.org",
          "external": true
        },
        {
          "title": "BSG Meet",
          "url": "https://meet.brainandspinegroup.org",
          "external": true
        }
      ]
    },
    {
      "id": "learn-platform",
      "title": "Learn",
      "scope": "learn",
      "links": [
        {
          "title": "Courses",
          "url": "/courses"
        },
        {
          "title": "Help",
          "url": "https://learn.brainandspinegroup.org/help/"
        },
        {
          "title": "Account",
          "url": "/account"
        }
      ]
    }
  ],
  "footerLegal": [
    {
      "title": "Privacy Policy",
      "url": "https://brainandspinegroup.org/privacy-policy/"
    },
    {
      "title": "Terms of Service",
      "url": "https://brainandspinegroup.org/terms-of-service/"
    },
    {
      "title": "Cookies Settings",
      "url": "https://brainandspinegroup.org/cookies-settings/"
    }
  ],
  "footerNonprofit": "Brain and Spine Group is 501(c)3 charity.",
  "footerCopyright": "© Brain & Spine Group, Inc. All Rights Reserved.",
  "fixtureName": "Fixture Person",
  "fixtureEmail": "fixture@example.org"
};
export default defaults;